// extracted by mini-css-extract-plugin
var _1 = "_VkqoNoeYK7J6Tpbce9Y";
var _2 = "GqRi3dpKZg7uuJgE2mzd";
export { _1 as "Select", _2 as "description" }
